import { useParams } from "react-router-dom"
import { useRefreshOnInvalidation } from "lib/graphql/use-refresh-on-invalidation"
import { useScheduleByMethodId } from "routes/schedule/compare/use-schedule-by-method-id"
import { Lazy } from "lib/make-lazy"
import { IS_LOADING } from "lib/graphql/return-is-loading-on-each-request"
import LoadingScreen from "minimals-template/components/LoadingScreen.js"

export function CompareDocuments({ retry }) {
    const { destination, source, other } = useParams()
    const refresh = useRefreshOnInvalidation("editSchedule", "rawSchedule", "draftHistoryEntry")
    const scheduleDestination = useScheduleByMethodId(destination, refresh.id)
    const scheduleSource = useScheduleByMethodId(source, refresh.id)
    const scheduleOther = useScheduleByMethodId(other, refresh.id)

    if ([scheduleDestination, scheduleSource, scheduleOther].includes(IS_LOADING)) {
        return <LoadingScreen description="Loading schedules..." />
    }

    return (
        <Lazy
            importer={() => import("routes/schedule/compare/comparisonView")}
            extract="ComparisonView"
            key={refresh.id}
            destination={scheduleDestination}
            source={scheduleSource}
            other={scheduleOther}
            retry={retry}
        />
    )
}
